import { apiService } from "../../../components/api/apiService";

const BASE = "/api/DataModels";

export interface DataModelCatalogRow {
  id: string;
  uuid: string;
  modelName: string;
  description: string;
  type: string;
  groupUuid: string | null;
  status: string;
  tags: string[];
}

function pick(raw: Record<string, unknown>, k: string, kAlt?: string): string {
  const v = raw[k] ?? (kAlt ? raw[kAlt] : undefined);
  return v == null ? "" : String(v).trim();
}

function mapRow(raw: Record<string, unknown>): DataModelCatalogRow {
  const tagsRaw = raw.tags ?? raw.Tags;
  const tags = Array.isArray(tagsRaw) ? tagsRaw.map((t) => String(t)) : [];
  const id = pick(raw, "id", "Id");
  const uuid = pick(raw, "uuid", "Uuid") || id;
  const gu = raw.groupUuid ?? raw.GroupUuid;
  const groupUuid = gu == null || gu === "" ? null : String(gu);
  return {
    id,
    uuid,
    modelName: pick(raw, "modelName", "ModelName"),
    description: pick(raw, "description", "Description"),
    type: pick(raw, "type", "Type"),
    groupUuid,
    status: pick(raw, "status", "Status"),
    tags,
  };
}

export const dataModelsCatalogService = {
  /** GET /api/DataModels — used by Resource Access resource picker (checkbox list). */
  async list(): Promise<DataModelCatalogRow[]> {
    const data = await apiService.get(BASE, {}, "backend");
    const list = data?.dataModels ?? data?.DataModels ?? [];
    if (!Array.isArray(list)) return [];
    return list.map((item: Record<string, unknown>) => mapRow(item));
  },
};
